<template>
  <div>
    <v-row class="mt-4" v-for="n in 4" :key="n">
      <v-col cols="12">
        <v-card outlined class="px-4 py-3 mt-2" height="70">
          <v-skeleton-loader type="text" class="mb-2" width="50" />
          <div class="d-flex align-center justify-space-between">
            <div>
              <v-skeleton-loader type="text" width="300" />
            </div>
            <div class="d-flex">
              <v-skeleton-loader type="text" width="50" />
              <v-skeleton-loader type="text" width="50" />
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'ReportSkeleton',
}
</script>
